module.exports = __webpack_public_path__ + "src/img/icon/icon_error.ee4ab81121163f1a17c055625d4df337.png";